import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/motion/Reveal";
import { RevealImage } from "../components/motion/RevealImage";
import { siteInfo } from "../data/site";

export function Privacy() {
  return (
    <>
      <SEO
        title="Privacy | The Deposit Seed House"
        description="Privacy information for The Deposit Seed House website."
        canonicalPath="/privacy"
      />
      <section className="page-hero page-hero--privacy">
        <Reveal className="page-hero__content">
          <p className="eyebrow">Privacy</p>
          <h1>Privacy and booking data</h1>
          <p>Guest accounts, booking requests, and email preferences are handled by The Deposit Seed House booking system.</p>
          <div className="page-hero__actions">
            <Link className="button button--primary" to="/contact">
              Ask a privacy question
            </Link>
            <Link className="button button--light" to="/apartments">
              View apartments
            </Link>
          </div>
        </Reveal>
      </section>
      <section className="section legal-section">
        <div className="legal-layout">
          <Reveal as="article" className="prose legal-panel">
            <h2>Booking and account information</h2>
            <p>
              When you check availability, request a stay, create a guest account, or update a saved account, we collect the details needed to manage that request: dates, apartment selection, guest counts, name, email, phone number, notes, account credentials, and booking status.
            </p>
            <p>
              Guest account passwords are stored as secure password hashes. Booking requests are reviewed by the owner before a stay is confirmed, and temporary holds may expire or be cancelled if the stay is not confirmed.
            </p>
            <h2>Email preferences</h2>
            <p>
              If you opt in to Deposit Seed House offers or discount emails, we store your email preference with your guest or signup details. You can opt out from your account settings or by using the unsubscribe link included in marketing emails.
            </p>
            <h2>Contact forms and operational tools</h2>
            <p>
              Contact page inquiries are sent through The Deposit Seed House booking system. We collect the name, email, phone number, subject, message, and optional email preference needed to respond, log delivery status, and manage opted-in guest communications.
            </p>
            <h2>Contact</h2>
            <p>
              Questions can be directed to <a href={siteInfo.phoneHref}>{siteInfo.phone}</a>.
            </p>
          </Reveal>
          <aside className="legal-visual" aria-hidden="true">
            <RevealImage src="/assets/site/building-entry.jpg" alt="" />
          </aside>
        </div>
      </section>
    </>
  );
}
